// 9fbef606107a605d69c0edbcd8029e5d 
import { APPLY_NOW_MODAL_REDUCER_PATTERN } from '../../../../../constants/reducer.constants';

const APPLY_NOW_MODAL_CONSTANTS = {
  APPLY_NOW_MODAL_TOGGLE: `${APPLY_NOW_MODAL_REDUCER_PATTERN}TOGGLE`,
};

export default APPLY_NOW_MODAL_CONSTANTS;
